/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 16 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 2.5c-1.57 0-2.985.657-3.988 1.712l.877-.2a.5.5 0 0 1 .222.976l-2.197.5A.5.5 0 0 1 2.303 5V2.5a.5.5 0 0 1 1 0v1.007A6.5 6.5 0 0 1 14.5 8a.5.5 0 0 1-1 0A5.5 5.5 0 0 0 8 2.5Zm-6 5a.5.5 0 0 1 .5.5 5.5 5.5 0 0 0 9.488 3.788l-.877.2a.5.5 0 1 1-.222-.976l2.197-.5a.5.5 0 0 1 .611.488v2.5a.5.5 0 0 1-1 0v-1.007A6.5 6.5 0 0 1 1.5 8a.5.5 0 0 1 .5-.5Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgRefresh)
export default Memo
